import { createStore, applyMiddleware, combineReducers } from 'redux';
import reduxThunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import rootReducer from './rootReducer';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [],
  whitelist: ['breadcrumb', 'appAnnouncements']
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  combineReducers({ rootReducer, persistedReducer }),
  (process.env.NODE_ENV === 'production')
    ? applyMiddleware(reduxThunk)
    : composeWithDevTools(applyMiddleware(reduxThunk, logger)),
);

if (module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newReducer = combineReducers({ rootReducer, persistedReducer });
    store.replaceReducer(newReducer);
  });
}

export const persistor = persistStore(store);

export default store;
